/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './right-side.style.css';
import Logo from '../../media/kx-logo.png';
import LogoBlack from '../../media/kx-logo-black.png';
import { Image, Button, Table, Header, Form, Input } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import SignupImg from '../../media/rs-backgrounds/signup-login-bg.jpg';
import LoginImg from '../../media/rs-backgrounds/signup-login-bg.jpg';
import TOSImg from '../../media/rs-backgrounds/bg-2.jpg';
import BasicInfoImg from '../../media/rs-backgrounds/basic-info-bg.jpg';
import AccountInfo1Img from '../../media/rs-backgrounds/ai1-bg.jpg';
import AccountInfo2Img from '../../media/rs-backgrounds/ai23-bg.jpg';
import AccountInfo3Img from '../../media/rs-backgrounds/ai23-bg.jpg';
import AccountInfo4Img from '../../media/rs-backgrounds/ai4-bg.jpg';
import Blur from '../../media/rs-backgrounds/bg-blur.jpg';
import Hero from '../../media/rs-backgrounds/hero-vector.svg';
import WhiteLogo from '../../media/rs-backgrounds/Logo.svg';
import API from '../../utility/API'
import Ship from '../../media/thanks-ship.svg'
import Facebook from '../../media/facebook.svg'
import LinkedIn from '../../media/linkedin.svg'
import Twitter from '../../media/tweeter.svg'
import {getWlBackGroundColor,getWhiteLabelCustomerName,wlGetLogoImage,wlGetLogoClassName,getRightSideContainer} from "../../util"


export class RightSide extends Component {
  
  render() {
    let wlCustomerName = getWhiteLabelCustomerName()

    let cssClass = "rs-container"
    let logoClassName
    let logoImage

    if (wlCustomerName.length > 0) {
      cssClass = getRightSideContainer()
      logoClassName = wlGetLogoClassName()
      logoImage = wlGetLogoImage()
    }

    console.log("XXX : ",cssClass,logoClassName,logoImage)
    
    return (
      <div className={cssClass}>
         
        {wlCustomerName.length === 0 ?
        <div>
        <div className="rs-header">
          <Image className="rs-logo"style={window._env_.WL == "false"?{width:"auto", height:"40px"}:{width: "auto", height:"40px"}} src={WhiteLogo} />
          {/* <p className="rs-subtitle">Customs clearance simplified.</p> */}
        </div>
        <div className="rs-hero">
          <Image src={Hero} className="rs-bg" />
        </div>
        </div>
        :
        <Image className={logoClassName}  src= {logoImage}/>}
        
        
      </div>
    );
          
  }
}

export class ThanksRS extends Component {
  render() {
    return (
      <div className="thanks-container">
        {/* <div className="thanks-header">
          <Image className="rs-logo" src={WhiteLogo} />
          <span className="rs-subtitle">We sent you an email. </span>
        </div> */}
        <div className="rs-hero">
          <Image src={Ship} className="rs-bg" />
        </div>
        <div>
          <center>
            <p className='thanks-title'>Thanks for signing up!</p>
            <p className='thanks-note'>We will send you an email shortly to setup your account and onboard to our application.</p>
            <p className='thanks-note-gray'>Don't forget to look in your spam folder.</p>
            <p className='thanks-note-gray'><a href="/">Back to login</a> </p>
            <div className='social-media'>
              <Image className='social-media-icon' src={Twitter} />
              <Image className='social-media-icon' src={Facebook} />
              <Image className='social-media-icon' src={LinkedIn} />
            </div>
          </center>
        </div>
      </div>
    );
  }
}

// export class SignupRS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           {/* <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data">Do you already have an account?</h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">You can login by clicking on the button below. To skip this next time,
//              you can ask us to remember your login credentials.</p></Table.Cell>
//               </Table.Row>
//             </Table.Body>
//           </Table> */}
//         </div>
//         <div>
//           <Image src={SignupImg} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export default SignupRS;

// export class LoginRS extends Component {
//   constructor () {
//     super();
//     this.state = {
//       showForm: false,
//       submitted: false
//     }
//   }

//   handleChange = (e, { name, value }) => this.setState({ [name]: value })

//   handleSubmit = () => {
//     API.inquiry(
//       this.state.firstName + ' ' + this.state.lastName,
//       this.state.companyName,
//       this.state.email,
//       this.state.jobTitle,
//       this.state.shipmentNumber,
//       this.state.phoneNumber
//     ).then(response => {
//       return response.json()
//     }).then(responseData => {
//       console.log(responseData)
//       this.setState({ submitted: true, showForm: false })
//     })
//   }

//   render() {
//     let {firstName, lastName, phoneNumber, shipmentNumber, email, companyName, jobTitle} = this.state
//     return (
//       <div>
//         {/* {this.state.showForm ?  */}
//             {/* <div className='rs-form'>
//             <div>
//             <Header as= 'h1'>Sign up</Header>
//             <br />
//               <Form>
//                 <Form.Group widths='equal'>
//                   <Form.Field>
//                   <label className='inquiryLabel'>FIRST NAME</label>
//                   <Form.Input 
//                     name='firstName' 
//                     value={firstName}
//                     fluid className='leftInput' 
//                     onChange={this.handleChange.bind(this)}
//                   />
//                   </Form.Field>
//                   <Form.Field>
//                   <label>LAST NAME</label>
//                   <Form.Input 
//                     name='lastName'
//                     value={lastName}
//                     fluid 
//                     className='rightInput'
//                     onChange={this.handleChange.bind(this)}
//                   />
//                   </Form.Field>
//                 </Form.Group>
//                 <Form.Group widths='equal'>
//                   <Form.Field>
//                   <label className='inquiryLabel'>PHONE NUMBER</label>
//                   <Form.Input 
//                     name='phoneNumber' 
//                     value={phoneNumber}
//                     fluid 
//                     className='leftInput' 
//                     onChange={this.handleChange.bind(this)}
//                   />
//                   </Form.Field>
//                   <Form.Field>
//                   <label>EMAIL ADDRESS</label>
//                   <Form.Input 
//                     name='email' 
//                     value={email}
//                     fluid 
//                     className='rightInput' 
//                     onChange={this.handleChange.bind(this)}
//                   />
//                   </Form.Field>
//                 </Form.Group>
//                 <Form.Field>
//                   <label className='inquiryLabel'>COMPANY NAME</label>
//                   <Form.Input 
//                     name='companyName' 
//                     value={companyName}
//                     fluid 
//                     className='fullWidth'
//                     onChange={this.handleChange.bind(this)}
//                   />
//                 </Form.Field>
//                 <Form.Field>
//                   <label className='inquiryLabel'>JOB TITLE</label>
//                   <Form.Input 
//                     name='jobTitle' 
//                     value={jobTitle}
//                     fluid 
//                     className='fullWidth'
//                     onChange={this.handleChange.bind(this)}
//                   />
//                 </Form.Field>
//                 <Form.Field>
//                   <label className='inquiryLabel'>NUMBER OF SHIPMENTS IMPORTED IN US</label>
//                   <Form.Input 
//                     name='shipmentNumber' 
//                     value={shipmentNumber}
//                     fluid 
//                     className='fullWidth'
//                     onChange={this.handleChange.bind(this)}
//                   />
//                 </Form.Field>
//                 <Button onClick={this.handleSubmit} className='signupNowForm'> Sign up now</Button>
//                 <Button onClick={()=> {this.setState({ showForm: !this.state.showForm })}}className='cancel'> Cancel </Button>
//               </Form>
//               </div>
//             </div>
//         : */}
//         <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             {/* <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image className='RSLogo' src={Logo} /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className='rsHeader'>Thank you for your interest!</h3></Table.Cell>
//               </Table.Row>
              
//               {!this.state.showForm && !this.state.submitted ?
//               <div>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">We are currently enrolling pilot customers. <br/> If you are interested in becoming one, sign up here.</p>
//                 </Table.Cell>
//               </Table.Row>

//               <Table.Row>
//                 <Table.Cell>
//                   <Button onClick={() => {this.setState({ showForm: !this.state.showForm })}} inverted className='signupNow'>Signup now</Button> <br/>
//                 </Table.Cell>
//               </Table.Row>
//               </div>

//               : null
//               }
              

//               <Table.Row>
//                 <Table.Cell>
//                   <Button href='https://www.klearexpress.com/' className='returnHome'>Return to homepage</Button>
//                 </Table.Cell>
//               </Table.Row>


//               <Table.Row>
//               </Table.Row>
//             </Table.Body> */}
//           </Table>
//         </div>

//         <div>
//           <Image src={SignupImg} fluid className="rs-bg" />
//         </div>
//         </div>
//         {/* // }       */}
//       </div>
//     );
//   }
// }

// export class ForgotPasswordRS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data">Not already a customer?</h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">If this is your first time here please click below to begin the sign-up process.
//                   Our aim is to make this step-by-step process as friendly as possible.
//                   We’re excited to have you on board!</p>
//                 </Table.Cell>
//               </Table.Row>
//               <Table.Row>
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>

//         <div>
//           <Image src={LoginImg} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class ResetPasswordRS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data">Not already a customer?</h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">If this is your first time here please click below to begin the sign-up process.
//                   Our aim is to make this step-by-step process as friendly as possible.
//                   We’re excited to have you on board!</p>
//                 </Table.Cell>
//               </Table.Row>
//               <Table.Row>
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>

//         <div>
//           <Image src={LoginImg} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class ThanksRS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data">Do you already have an account?</h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">You can login by clicking on the button below. To skip this next time,
//              you can ask us to remember your login credentials.</p></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell>
//                   <Link className="rs-data rs-button" to='/' ui very basic><Button inverted>Login</Button></Link></Table.Cell>
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={SignupImg} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class TermsOfServiceRS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data"></h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">Please read our Terms and Conditions of Service. We know nobody likes to read the fine print, but this is a very important step. Once you’ve read, and hopefully agreed, you can proceed.
//                   </p>
//                 </Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 {/* <Table.Cell><Link className="rs-data rs-button" to='/'><Button inverted>Login</Button></Link></Table.Cell> */}
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={TOSImg} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class ViewTermsRS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data"></h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 {/* <Table.Cell><p className="rs-data">Please read our Terms and Conditions of Service. We know nobody likes to read the fine print, but this is a very important step.
//                   </p>
//                 </Table.Cell> */}
//               </Table.Row>
//               <Table.Row>
//                 {/* <Table.Cell><Link className="rs-data rs-button" to='/'><Button inverted>Login</Button></Link></Table.Cell> */}
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={TOSImg} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class BasicInfoRS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data"></h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">We need to get to know you in order to tailor
//                 our services to your needs. Let’s start with the basics.</p></Table.Cell>
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={BasicInfoImg} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class AccountInfo1RS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={LogoBlack} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3>We will help you track your shipment across the globe</h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p>Whether you’re a small business with relatively few shipments annually,
//                   or a high-volume monthly importer, we’re here to help.</p></Table.Cell>
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={AccountInfo1Img} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class AccountInfo2RS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data">We will help you track your shipment across the globe</h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">It’s critical for us to understand your standard shipping process. It
//                   doesn’t matter whether you prefer FOB, CIF, DAP (or anything else in between). Let us know your typical
//                   terms of sale and which freight forwarders, carriers, and brokers you use to navigate the global supply
//                   chain.</p>
//                 </Table.Cell>
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={AccountInfo2Img} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class AccountInfo3RS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data">We will help you track your shipment across the globe</h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell>
//                   <p className="rs-data">You need a customs bond to import goods, plain and simple. If you already
//                     have one, we need the details. If you don’t have one, it’s not a problem. We’ll take care of it.
//                   </p>
//                 </Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 {/* <Table.Cell><Link className="rs-data rs-button" to='/'><Button inverted>Login</Button></Link></Table.Cell> */}
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={AccountInfo3Img} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class AccountInfo4RS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">Here’s where you can customize
//                   your KlearExpress experience. We’re happy for you to be as hands-on or
//                   hands-off as you like. And don’t worry, you can change these setting and
//                   preferences at any point and time.</p>
//                 </Table.Cell>
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={AccountInfo4Img} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class PowerOfAttorneyRS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><h3 className="rs-data">We will help you track your shipment across the globe</h3></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">The Power of Attorney (POA) authorizes us to conduct business on your
//                   behalf. Without a valid POA we can’t help you get your goods from point A to point B. So please take your
//                   time to carefully fill in and review the document. Thanks!</p>
//                 </Table.Cell>
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={AccountInfo3Img} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }

// export class AddTeamRS extends Component {
//   render() {
//     return (
//       <div>
//         <div className="rs-container">
//           <Table className="rs-table" ui very basic table>
//             <Table.Body>
//               <Table.Row>
//                 <Table.Cell><Image src={Logo} size='medium' disabled /></Table.Cell>
//               </Table.Row>
//               <Table.Row>
//                 <Table.Cell><p className="rs-data">We will help you track your shipment from where you are without logging in our application, whenever possible.</p>
//                 </Table.Cell>
//               </Table.Row>
//             </Table.Body>
//           </Table>
//         </div>
//         <div>
//           <Image src={AccountInfo4Img} fluid className="rs-bg" />
//         </div>
//       </div>
//     );
//   }
// }